import {
  BookOpen,
  Briefcase,
  type IconComponent,
  KeyRound,
  Network,
  ShieldAlert,
  UserMinus,
  Users,
} from "@norican/icons";

import type { UserProfile } from "@/lib/api";

/**
 * The chapters of the help centre, in reading order.
 *
 * One chapter per job the product does, plus roles and a glossary. A chapter
 * is hidden when the person cannot reach the feature it explains, exactly as
 * the nav hides the feature: help for a page you cannot open is not help.
 */
export type HelpChapter = {
  to: string;
  label: string;
  icon: IconComponent;
  /** One line under the title on the overview. */
  blurb: string;
  show?: (me: UserProfile | undefined) => boolean;
};

export const CHAPTERS: HelpChapter[] = [
  {
    to: "/help",
    label: "Overview",
    icon: BookOpen,
    blurb: "Where to start, the four questions people arrive with, and when to call SecOps.",
  },
  {
    to: "/help/roles",
    label: "Roles and access",
    icon: Users,
    blurb: "The three HROps roles, the approvers, which one you hold and how access is granted.",
  },
  {
    to: "/help/leavers",
    label: "Leavers",
    icon: UserMinus,
    blurb: "The seven steps of an offboarding, the two phases, revert and re-enable.",
  },
  {
    to: "/help/risk",
    label: "Risk flags and access lists",
    icon: ShieldAlert,
    blurb: "What each severity does to a person, and the groups HR keeps.",
  },
  {
    to: "/help/org",
    label: "Organisation",
    icon: Network,
    blurb: "The directory snapshot, scenarios, and what is written to Active Directory.",
    show: (me) => me?.org_chart_enabled === true,
  },
  {
    to: "/help/workforce",
    label: "Workforce",
    icon: Briefcase,
    blurb: "Hires, exits, planned exits, future positions: the forms, the approval, the data.",
    show: (me) => me?.workforce_enabled === true,
  },
  {
    to: "/help/glossary",
    label: "Glossary",
    icon: KeyRound,
    blurb: "Every term the screens use, with the consequence where there is one.",
  },
];
